export default {
  'nav.categories': 'Catégories',
  'nav.home': 'Accueil',
  'nav.shoppingGuide': 'Guide d\u2019achat',
  'nav.review': 'Avis',
  'nav.shipping': 'Livraison',
  'nav.safety': 'Sécurité',
  'nav.buyNow': 'Acheter maintenant',
  'nav.language': 'Langue',

  'footer.tagline': 'Une ressource indépendante pour trouver des produits, vérifier le QC et acheter plus intelligemment.',
  'footer.disclaimer': 'Ce site web est une ressource informative indépendante et n\u2019est pas affilié, soutenu ni sponsorisé par USFans ou un quelconque vendeur. Vérifiez toujours les informations avant de commander.',
  'footer.quickLinks': 'Liens rapides',
  'footer.home': 'Accueil',
  'footer.guide': 'Guide USFans Spreadsheet',
  'footer.categories': 'Catégories',
  'footer.rights': 'Tous droits réservés.',
  'footer.language': 'Langue',

  'cta.exploreSpreadsheet': 'Explorer USFans Spreadsheet',
  'cta.buyNow': 'Acheter maintenant',
  'cta.startGuide': 'Commencer par le guide débutant',
  'cta.browseCategories': 'Voir toutes les catégories',
  'cta.readGuide': 'Lire le guide',
  'cta.readArticle': 'Lire le guide',
  'cta.continueMain': 'Aller au site principal',
  'cta.readSafety': 'Lire le guide de sécurité',
  'cta.backHome': 'Retour à l\u2019accueil',
};